// WithLoginOurService

import { useEffect, useState, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { PhoneNumberUtil } from "google-libphonenumber";

import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";

import axios from "axios";
import WithLoginHeader from "../../layout/Header/WithLoginHeader";
import Footer from "../../layout/Footer";
import { TOAST_ERROR, TOAST_SUCCESS, Encryption } from "../../config/common";
import { GenerateBom, GenerateBomReplacement } from "../../utils/api.services";
import { useNavigate } from "react-router-dom";
import { setLoader } from "../../Store/slices/MasterSlice";
import { useDispatch } from "react-redux";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import Constatnt from "../../config/constant";
import { GetUserProfile, getStateList } from "../../utils/api.services";
import DebrisRemovalModal from "../../component/DebrisRemovalModal";

import MapModal from "../MyestimatorHomeOwner/MapModal";

const WithLoginOurService = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    control,
    watch,
  } = useForm();

  const mobileCodeRef = useRef(null);
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("");
  const phoneUtil = PhoneNumberUtil.getInstance();

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("");

  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedForHip, setIsCheckedForHip] = useState(false);
  const [valleyImageValue, setValleyImageValue] = useState([]);
  const [hipImageValue, setHipImageValue] = useState([]);
  const [valleyImagesError, setValleyImagesError] = useState("");
  const [hipImagesError, setHipImagesError] = useState("");
  const [valleyImages, setValleyImages] = useState([]);
  const [hipImages, setHipImages] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isServicesVisible, setIsServicesVisible] = useState(0);
  const [address, setAddress] = useState(null);
  const [postalCode, setPostalCode] = useState("");

  const [stateData, setStateData] = useState();
  const [selectedId, setSelectedId] = useState();
  const [selectedState, setSelectedState] = useState("Please Select State");
  const [siteAddress, setSiteAddress] = useState(null);

  const [coordinates, setCoordinates] = useState({
    latitude: null,
    longitude: null,
  });

  const [solarData, setSolarData] = useState(null);

  const [isSuggestion, setIsSuggestion] = useState(false);
  const [userdata, setUserdata] = useState();
  const [showMapModal, setShowMapModal] = useState(false);

  const dispatch = useDispatch();

  const isPhoneValid = (phone) => {
    // // Implement your phone number validation logic here if needed
    // return phone.length > 5;
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    const initIntlTelInput = () => {
      const inputElement = mobileCodeRef?.current;

      if (inputElement) {
        const iti = intlTelInput(inputElement, {
          initialCountry: "us",
          separateDialCode: true,
        });

        const updateCountryCodeStyle = () => {
          const selectedCountryData = iti.getSelectedCountryData();

          setSelectedCountry(selectedCountryData.iso2);
          const countryCodeElement = iti.telInput.parentElement.querySelector(
            ".iti__selected-flag",
          );

          if (countryCodeElement) {
            if (selectedCountryData.dialCode === "1") {
              countryCodeElement.style.backgroundColor = "#FFFFFF";
            } else {
              countryCodeElement.style.backgroundColor = "#FFFFFF";
            }
          }
        };
        updateCountryCodeStyle();
        iti.promise.then(() => {
          setSelectedCountryCode(iti.getSelectedCountryData().dialCode);
        });

        inputElement.addEventListener("countrychange", () => {
          setSelectedCountryCode(iti.getSelectedCountryData().dialCode);
          updateCountryCodeStyle();
        });
        return iti;
      }
      return null;
    };

    const itiInstance = initIntlTelInput();
    return () => {
      if (itiInstance) {
        itiInstance.destroy();
      }
    };
  }, [isFormVisible]);

  const allowMobileNumbers = (event) => {
    const input = event.key;
    const mobileNumber = event.target.value.replace(/\D/g, "");
    setValue("phone_number", event.target.value);
    if (mobileNumber.length >= 15 || !/^\d$/.test(input)) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    GetUserProfile({}).then((response) => {
      if (response?.code === 200) {
        //
        setUserdata(response?.data);
      } else {
        TOAST_ERROR(response.message);
      }
    });
  }, []);

  useEffect(() => {
    getStateList().then((response) => {
      if (response?.code === 200) {
        setStateData(response?.data);
      } else {
        TOAST_ERROR(response?.message);
      }
    });
  }, [getStateList]);

  const handleStateSelect = (stateName, id) => {
    setSelectedId(id);
    setValue("state_id", id);
    setSelectedState(stateName);
  };

  const handleCheckboxChange = (value) => {
    if (value == 1) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  };

  const handleCheckboxChangeForHip = (value) => {
    if (value == 1) {
      setIsCheckedForHip(true);
    } else {
      setIsCheckedForHip(false);
    }
  };

  const handleFileInputChange = (event, section) => {
    const selectedFiles = event.target.files;

    if (selectedFiles.length > 0 && selectedFiles.length <= 3) {
      if (section === "valley") {
        setValleyImageValue(selectedFiles);
        setValleyImagesError("");
        const imageUrls = [];
        for (let i = 0; i < selectedFiles.length; i++) {
          const file = selectedFiles[i];
          if (file.type.startsWith("image/")) {
            const imageUrl = URL.createObjectURL(file);
            imageUrls.push(imageUrl);
          }
        }
        setValleyImages(imageUrls);
      } else if (section === "hip") {
        setHipImageValue(selectedFiles);
        setHipImagesError("");
        const imageUrls = [];
        for (let i = 0; i < selectedFiles.length; i++) {
          const file = selectedFiles[i];
          if (file.type.startsWith("image/")) {
            const imageUrl = URL.createObjectURL(file);
            imageUrls.push(imageUrl);
          }
        }
        setHipImages(imageUrls);
      }
    } else {
      if (section === "valley") {
        setValleyImageValue([]);
        setValleyImagesError("The limit is 3 photos");
      } else if (section === "hip") {
        setHipImageValue([]);
        setHipImagesError("The limit is 3 photos");
      }
    }
  };
  const handleDeleteImage = (index, section) => {
    if (section === "valley") {
      const updatedImages = valleyImages.filter((_, i) => i !== index);
      setValleyImages(updatedImages);
      setValleyImageValue(updatedImages.map((img) => img.file));
    } else if (section === "hip") {
      const updatedImages = hipImages.filter((_, i) => i !== index);
      setHipImages(updatedImages);
      setHipImageValue(updatedImages.map((img) => img.file));
    }
  };

  const [pendingFormData, setPendingFormData] = useState(null);

  // Step 1: Initial Form Submit -> Opens Modal if Roof Replacement
  const handleInitialSubmit = (data) => {
    if (isServicesVisible === 2) {
      setPendingFormData(data);
      setShowDebrisModal(true);
    } else {
      finalizeSubmission(data);
    }
  };

  // Step 2: Finalize Submission (Called by Modal Save or Direct Submit)
  const finalizeSubmission = async (data, debrisOverride = null) => {
    data.valley_images = [];
    data.hip_images = [];

    if (coordinates && coordinates.latitude) {
      data.latitude = coordinates.latitude;
      data.longitude = coordinates.longitude;
    } else {
      console.warn(
        "Coordinates state is empty! Using fallback from data if valid.",
      );
    }
    data.country_code = `+${selectedCountryCode}`;

    if (isChecked === true) {
      data.valley_damaged_area = 1;
    } else {
      data.valley_damaged_area = 0;
    }

    if (isCheckedForHip === true) {
      data.hip_damaged_area = 1;
    } else {
      data.hip_damaged_area = 0;
    }

    if (isServicesVisible === 1) {
      data.service_name = "Roof Repair";
    }

    if (isServicesVisible === 2) {
      data.service_name = "Roof Replacement";

      // Use debrisOverride if available (latest from modal), otherwise state
      const sourceData = debrisOverride || debrisData;

      data.debris_type = sourceData.debris_type;
      data.custom_price = sourceData.custom_price;
      data.custom_count = sourceData.custom_count;
      data.underlayment_type = sourceData.underlayment_type;
      data.ventilation_type = sourceData.ventilation_type;
      data.vent_size = sourceData.vent_size;
      data.vent_price = sourceData.vent_price;
      data.vent_unit_cost = sourceData.vent_unit_cost;
      data.vent_quantity = sourceData.vent_quantity;
      data.pipe_flashing = sourceData.pipe_flashing;
      data.adjustable_pipe_flashing_qty =
        sourceData.adjustable_pipe_flashing_qty;
      data.valley_flashing_type = sourceData.valley_flashing_type;
      data.valley_ice_water = sourceData.valley_ice_water;
      data.ridge_cap_type = sourceData.ridge_cap_type;
    }

    dispatch(setLoader(true));
    if (valleyImageValue.length > 0) {
      const valleyUploadPromises = Array.from(valleyImageValue).map(
        async (file, index) => {
          try {
            // const response = await uploadToS3(file,"valley_image");
            // if (response && response.key) {
            //   const imageName = response.key.split("/").pop();
            //   data.valley_images.push(imageName);
            // } else {
            //   console.error(
            //     "Upload failed or response.key is undefined for file:",
            //     file
            //   );
            // }

            const formData = new FormData();
            formData.append("file", file);
            formData.append("file_name", file.name);
            formData.append("folder_name", "valley_image");

            const response = await axios.post(
              `${Constatnt.API_BASE_URL}/website/auth/upload-image`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  token: Encryption(localStorage.getItem("Ptoken"), true),
                  "api-key": Encryption(Constatnt.API_KEY, true),
                  "Accept-Language": Constatnt.language,
                  app: "A",
                },
              },
            );
            if (response && response.data.data.key) {
              const imageName = response.data.data.key.split("/").pop();
              data.valley_images.push(imageName);
            } else {
              console.error(
                "Upload failed or response.key is undefined for file:",
                file,
              );
            }
            return response;
          } catch (error) {
            return null;
          }
        },
      );
      await Promise.allSettled(valleyUploadPromises);
    }

    if (hipImageValue.length > 0) {
      const hipUploadPromises = Array.from(hipImageValue).map(
        async (file, index) => {
          try {
            // const response = await uploadToS3(file, "hip_image");
            // if (response && response.key) {
            //   const imageName = response.key.split("/").pop();
            //   data.hip_images.push(imageName);
            // } else {
            //   console.error(
            //     "Upload failed or response.key is undefined for file:",
            //     file
            //   );
            // }
            const formData = new FormData();
            formData.append("file", file);
            formData.append("file_name", file.name);
            formData.append("folder_name", "hip_image");

            const response = await axios.post(
              `${Constatnt.API_BASE_URL}/website/auth/upload-image`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  token: Encryption(localStorage.getItem("Ptoken"), true),
                  "api-key": Encryption(Constatnt.API_KEY, true),
                  "Accept-Language": Constatnt.language,
                  app: "A",
                },
              },
            );
            if (response && response.data.data.key) {
              const imageName = response.data.data.key.split("/").pop();
              data.hip_images.push(imageName);
            } else {
              console.error(
                "Upload failed or response.key is undefined for file:",
                file,
              );
            }
            return response;
          } catch (error) {
            return null;
          }
        },
      );
      await Promise.allSettled(hipUploadPromises);
    }

    try {
      let response;
      if (isServicesVisible === 2) {
        
        response = await GenerateBomReplacement({ ...data });
      } else {
        response = await GenerateBom({ ...data });
      }
      if (response?.code === 200) {
        TOAST_SUCCESS(response.message);
        navigate("/view-estimator-review", {
          state: {
            bom_id: response.data.bom_id,
            state_id: selectedId,
            bomDetails: data,
          },
        });
      } else {
        TOAST_ERROR(response.message);
      }
    } catch (error) {
      TOAST_ERROR("An error occurred while generating BOM");
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleSelect = (address) => {
    setSiteAddress(address);
    setValue("site_address", address);
    clearErrors("site_address");

    setShowMapModal(true);

    geocodeByAddress(address)
      .then((results) => {
        const addressComponents = results[0].address_components;
        const postalCodeComponent = addressComponents.find((component) =>
          component.types.includes("postal_code"),
        );

        if (postalCodeComponent) {
          setPostalCode(postalCodeComponent.long_name);
        } else {
          setPostalCode("");
        }

        return getLatLng(results[0]);
      })
      .then((latLng) => {
        setCoordinates({ latitude: latLng.lat, longitude: latLng.lng });
        setValue("latitude", latLng.lat);
        setValue("longitude", latLng.lng);
      })
      .catch((error) => {
        setPostalCode("");
        setCoordinates({ latitude: null, longitude: null });
      });
  };

  const handleMapSelection = (selectedAddress, latlong) => {
    setSiteAddress(selectedAddress);
    if (latlong?.lat !== coordinates.lat && latlong?.lng !== coordinates.lng) {
      setCoordinates({ latitude: latlong?.lat, longitude: latlong?.lng });
    }
    setShowMapModal(false);
    setValue("site_address", selectedAddress);
    setValue("latitude", latlong?.lat || null);
    setValue("longitude", latlong?.lng || null);
  };

  const closeMapModal = () => setShowMapModal(false);

  // Debris Removal State (Consolidated)
  const [debrisData, setDebrisData] = useState({
    type: "Dumpster",
    dumpsterPrice: 0,
    dumpsterQuantity: 0,
    dumpTrailerPrice: "",
    dumpTrailerQuantity: 0,
  });

  const [showDebrisModal, setShowDebrisModal] = useState(false);

  const handleDebrisModalSave = (data) => {
    setShowDebrisModal(false);
    setDebrisData(data);
    if (pendingFormData) {
      finalizeSubmission(pendingFormData, data);
    }
  };

  const fetchData = async () => {
    try {
      if (siteAddress && isServicesVisible === 2) {
        const url = `https://solar.googleapis.com/v1/buildingInsights:findClosest?location.latitude=${coordinates.latitude}&location.longitude=${coordinates.longitude}&requiredQuality=HIGH&key=AIzaSyA4vgo78Hc2QMHjL33_bM3DNpd4e-oCb8E`;

        const response = await axios.get(url);
        setSolarData(response.data.solarPotential.wholeRoofStats.areaMeters2);
        setValue(
          "sq_ft",
          (
            response.data.solarPotential.wholeRoofStats.areaMeters2 * 10.7639
          ).toFixed(2),
        );
      } else {
        setValue("sq_ft", "");
      }
    } catch (error) {}
  };

  return (
    <>
      <WithLoginHeader />

      <section className="our-service-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-sm-12 col-12">
              <h2 className="web-heading">
                Protact Your Home With Durable Roofing
              </h2>
              <p className="serviceTopText">
                At our core, we are dedicated to providing a seamless and
                efficient experience for homeowners, contractors,and anyone in
                need of accurate and reliable roof estimates. Our user-friendly
                interface and advanced technology make it easy for users to
                input their project detailsand receive instant, precise
                estimates.
              </p>
            </div>
          </div>
          <div className="row">
            <div
              className="d-flex justify-content-center align-items-center flex-wrap"
              style={{ gap: "20px" }}
            >
              <div
                className={`col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 aboutUsGrideTwo ${
                  isServicesVisible === 1 ? "selected-card" : ""
                }`}
                onClick={() => {
                  setIsFormVisible(true);
                  setIsServicesVisible(1);
                  setSiteAddress("");
                  setValue("sq_ft", "");
                }}
              >
                <div className="aboutUsImgBox">
                  <img
                    src="assets/images/banner/roof-1.jpg"
                    alt="roof"
                    className="roof-img img-cover"
                  />
                  <p className="roofServiceLabel">Roof Repair</p>
                </div>
                <div className="roofBody">
                  <p className="serviceText">
                    Partial repair and patching your Roof
                  </p>
                </div>
              </div>

              <div
                className={`col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 aboutUsGrideTwo ${
                  isServicesVisible === 2 ? "selected-card" : ""
                }`}
                onClick={() => {
                  setIsFormVisible(true);
                  setIsServicesVisible(2);
                  setSiteAddress("");
                  setValue("sq_ft", "");
                }}
              >
                <div className="aboutUsImgBox">
                  <img
                    src="assets/images/banner/roof-2.jpg"
                    alt="roof"
                    className="roof-img img-cover"
                  />
                  <p className="roofServiceLabel">Roof Replacement</p>
                </div>
                <div className="roofBody">
                  <p className="serviceText">Complete removal of your Roof</p>
                </div>
              </div>
            </div>
          </div>

          {isFormVisible && (
            <div className="row justify-content-center">
              <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                <div className="generatBOMBox">
                  <h2 className="web-heading">Generate BOM</h2>
                  <form onSubmit={handleSubmit(handleInitialSubmit)}>
                    <div className="row">
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="" className="webLabel">
                            Project Address Or site address
                          </label>

                          <PlacesAutocomplete
                            value={siteAddress}
                            GooglePlace
                            onChange={(address) => {
                              setSiteAddress(address);
                              clearErrors("site_address");
                            }}
                            onSelect={handleSelect}
                            className="my-autocomplete-input form-control"
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div className="w-100 position-relative">
                                <div className="mv-3">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="editWebInput"
                                      placeholder="Enter your address"
                                      aria-label="Recipient's username"
                                      aria-describedby="basic-addon2"
                                      value={siteAddress}
                                      {...register("site_address", {
                                        required: "Enter your address",
                                      })}
                                      autoComplete="off"
                                      {...getInputProps({
                                        placeholder: "Enter your address",
                                      })}
                                    />
                                  </div>
                                  <label className="errorc ms-1 p-1">
                                    {errors.site_address?.message}
                                  </label>
                                </div>
                                <div
                                  className={`suggestions-container w-75 p-2 ${
                                    isSuggestion && "border rounded"
                                  }`}
                                >
                                  {siteAddress?.trim() === "" ? (
                                    ""
                                  ) : loading ? (
                                    <div className="text-secondary blue_29">
                                      Loading...
                                    </div>
                                  ) : null}
                                  {suggestions.length > 0
                                    ? setIsSuggestion(true)
                                    : setIsSuggestion(false)}
                                  {suggestions.map((suggestion, key) => {
                                    const style = {
                                      backgroundColor: suggestion.active
                                        ? "#b4009d10"
                                        : "#fff",
                                      textAlign: "left",
                                      cursor: "pointer",
                                      width: "100%",
                                      fontSize: "1rem",
                                      borderRadus: "10px",
                                      padding: "0%",
                                    };

                                    return (
                                      <div
                                        className="suggestion-item p-3"
                                        key={key}
                                        {...getSuggestionItemProps(suggestion, {
                                          style,
                                        })}
                                      >
                                        {suggestion.description}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        </div>
                      </div>

                      <MapModal
                        show={showMapModal}
                        onClose={closeMapModal}
                        onSelect={handleMapSelection}
                        address={siteAddress}
                        fetchData={fetchData}
                        setShowMapModal={setShowMapModal}
                        coordinates={{
                          lat: coordinates.latitude,
                          lng: coordinates.longitude,
                        }}
                      />

                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="" className="webLabel">
                            Customer Name
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="editWebInput"
                              placeholder="Please enter customer name."
                              aria-label="Customer Name"
                              aria-describedby="basic-addon1"
                              {...register("customer_name", {
                                required: "Customer name is required",
                                pattern: {
                                  value: /^(?!\s+$)[a-zA-Z ]{3,30}$/,
                                  message:
                                    "Customer name can only contain letters.",
                                },
                              })}
                            />
                          </div>
                          {errors.customer_name && (
                            <p className="error-message">
                              {errors.customer_name.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="phone_number" className="webLabel">
                            Phone Number
                          </label>
                          <div className="input-group">
                            <Controller
                              name="phone_number"
                              control={control}
                              rules={{
                                required: "Please enter phone number",
                                pattern: {
                                  value: /^\d{10,12}$/,
                                  message: "Please enter valid phone number",
                                },
                              }}
                              render={({ field }) => (
                                <>
                                  <input
                                    {...field}
                                    type="text"
                                    id="phone_number"
                                    maxLength={12}
                                    ref={mobileCodeRef}
                                    className="editWebInput telephoneInput"
                                    placeholder="0000000000"
                                    onKeyUp={(e) => allowMobileNumbers(e)}
                                    name="phone_number"
                                  />
                                  {errors.phone_number && (
                                    <div className="invalid-feedback">
                                      {errors.phone_number.message}
                                    </div>
                                  )}
                                </>
                              )}
                            />
                          </div>
                          {errors.phone_number && (
                            <span className="errorText">
                              {errors.phone_number.message}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="" className="webLabel">
                            Area
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="editWebInput"
                              placeholder="Please enter area."
                              aria-label="Area"
                              aria-describedby="basic-addon1"
                              {...register("area", {
                                required: "Area is required",
                                // pattern: {
                                //   value: /^[a-zA-Z0-9 ]*$/,
                                //   message:
                                //     "Area can only contain letters, digits, and spaces.",
                                // },
                              })}
                            />
                          </div>
                          {errors.area && (
                            <p className="error-message">
                              {errors.area.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="" className="webLabel">
                            Sq ft
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="editWebInput"
                              placeholder="Please enter sq ft"
                              aria-label="Sq ft"
                              aria-describedby="basic-addon1"
                              {...register("sq_ft", {
                                required: "Sq_ft is required",
                                pattern: {
                                  value: /^[0-9]*\.?[0-9]*$/,
                                  message:
                                    "Sq_ft can only contain digits and a decimal point.",
                                },
                              })}
                            />
                          </div>
                          {errors.sq_ft && (
                            <p className="error-message">
                              {errors.sq_ft.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="" className="webLabel">
                            H/R Ln ft
                          </label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="editWebInput"
                              placeholder="Please enter hr in ft"
                              aria-label="Username"
                              aria-describedby="basic-addon1"
                              {...register("hr_ln_ft", {
                                required: "Hr_ln_ft is required",
                                pattern: {
                                  value: /^[a-zA-Z0-9]*$/,
                                  message:
                                    " Hr_ln_ft can only contain letters, digits, and the letter.",
                                },
                              })}
                            />
                          </div>
                          {errors.hr_ln_ft && (
                            <p className="error-message">
                              {errors.hr_ln_ft.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="" className="webLabel">
                            Valley Ln ft
                          </label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="editWebInput"
                              placeholder="Please enter valley ln ft"
                              aria-label="Valley"
                              aria-describedby="basic-addon1"
                              {...register("valley_ln_ft", {
                                required: "Valley_ln_ft is required",
                                pattern: {
                                  value: /^[a-zA-Z0-9]*$/,
                                  message:
                                    " Valley_ln_ftcan only contain letters, digits, and the letter.",
                                },
                              })}
                            />
                          </div>
                          {errors.valley_ln_ft && (
                            <p className="error-message">
                              {errors.valley_ln_ft.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="" className="webLabel">
                            Edge of the roof / Fascia
                          </label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="editWebInput"
                              placeholder="Please enter Edge of the roof / Fascia"
                              aria-label="Valley"
                              aria-describedby="basic-addon1"
                              {...register("fascia", {
                                required: "Fascia is required",
                                pattern: {
                                  value: /^[a-zA-Z0-9]*$/,
                                  message:
                                    " Fascia  only contain letters, digits, and the letter.",
                                },
                              })}
                            />
                          </div>
                          {errors.fascia && (
                            <p className="error-message">
                              {errors.fascia.message}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 ProfileGrid">
                        <div className="editWebInputBox">
                          <label htmlFor="state" className="webLabel">
                            State
                          </label>
                          <div className="input-group">
                            <div className="dropdown w-100">
                              <button
                                className=" State-btn dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <b>{selectedState}</b>
                              </button>
                              <ul
                                className="dropdown-menu w-100"
                                style={{ height: "150px", overflow: "auto" }}
                              >
                                {stateData &&
                                  stateData.map((state, index) => (
                                    <li key={index}>
                                      <a
                                        className="dropdown-item"
                                        onClick={() =>
                                          handleStateSelect(
                                            state.states_name,
                                            state.id,
                                          )
                                        }
                                      >
                                        {state.states_name}
                                      </a>
                                    </li>
                                  ))}
                              </ul>
                            </div>

                            <input
                              type="hidden"
                              value={selectedId}
                              {...register("state_id", {
                                required: "State is required",
                              })}
                            />
                          </div>

                          {errors.state_id && (
                            <p className="error-message">
                              {errors.state_id.message}
                            </p>
                          )}
                          {/* Hidden inputs for latitude and longitude */}
                          <input type="hidden" {...register("latitude")} />
                          <input type="hidden" {...register("longitude")} />
                        </div>
                      </div>

                      {isServicesVisible != "2" && (
                        <>
                          <div className="col-12">
                            <h6 className="serviceFormSubHeading">
                              Is there a valley on the damages area?
                            </h6>
                            <div className="serviceYesNoBox">
                              <div className="YNBox">
                                <input
                                  type="checkbox"
                                  className="SignUpChaeckbox"
                                  id="yes1"
                                  onChange={() => {
                                    handleCheckboxChange(1);
                                  }}
                                  checked={isChecked}
                                />
                                <label className="webLabel" htmlFor="yes1">
                                  Yes
                                </label>
                              </div>
                              <div className="YNBox">
                                <input
                                  type="checkbox"
                                  className="SignUpChaeckbox"
                                  id="no1"
                                  onChange={() => {
                                    handleCheckboxChange(0);
                                  }}
                                  checked={!isChecked}
                                />
                                <label className="webLabel" htmlFor="no1">
                                  No
                                </label>
                              </div>
                            </div>
                            <div
                              className="yesUploadYouPhoto"
                              id="uploadSection1"
                              style={{ display: isChecked ? "block" : "none" }}
                            >
                              <h6 className="serviceFormSubHeading">
                                Upload a picture of the Damages
                              </h6>
                              <div className="serviceInputImgBox">
                                <div className="serviceInputFileBox">
                                  <img
                                    src="assets/images/icons/uploadImg.svg"
                                    alt="uploadImg"
                                    className="uploadImg"
                                  />
                                  <p className="uploadText">Upload</p>
                                  <input
                                    type="file"
                                    className="serviceInputFile"
                                    id="fileInput1"
                                    multiple
                                    onChange={(e) =>
                                      handleFileInputChange(e, "valley")
                                    }
                                  />
                                </div>

                                {valleyImages.length > 0 && (
                                  <div
                                    className="uploadedImagesContainer"
                                    id="container1"
                                  >
                                    {valleyImages.map((imageUrl, index) => (
                                      <div
                                        key={index}
                                        className="imageContainer"
                                      >
                                        <img
                                          src={imageUrl}
                                          alt={`Uploaded Image ${index}`}
                                          style={{
                                            width: "150px",
                                            height: "auto",
                                            marginBottom: "10px",
                                            position: "relative",
                                          }}
                                        />
                                        <button
                                          type="button"
                                          style={{
                                            position: "absolute",
                                            color: "red",
                                            fontSize: "24px",
                                            marginTop: "-19px",
                                            marginLeft: "-0.3%",
                                          }}
                                          onClick={() =>
                                            handleDeleteImage(index, "valley")
                                          }
                                        >
                                          x
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {valleyImagesError && (
                                  <p>{valleyImagesError}</p>
                                )}
                              </div>
                            </div>
                            <h6 className="serviceFormSubHeading">
                              Is there a hip on the damages area?
                            </h6>
                            <div className="serviceYesNoBox">
                              <div className="YNBox">
                                <input
                                  type="checkbox"
                                  className="SignUpChaeckbox"
                                  id="yes2"
                                  multiple
                                  onChange={() => {
                                    handleCheckboxChangeForHip(1);
                                  }}
                                  checked={isCheckedForHip}
                                />
                                <label className="webLabel" htmlFor="yes2">
                                  Yes
                                </label>
                              </div>
                              <div className="YNBox">
                                <input
                                  type="checkbox"
                                  className="SignUpChaeckbox"
                                  id="no2"
                                  onChange={() => {
                                    handleCheckboxChangeForHip(0);
                                  }}
                                  checked={!isCheckedForHip}
                                />
                                <label className="webLabel" htmlFor="no2">
                                  No
                                </label>
                              </div>
                            </div>
                            <div
                              className="yesUploadYouPhoto"
                              id="uploadSection2"
                              style={{
                                display: isCheckedForHip ? "block" : "none",
                              }}
                            >
                              <h6 className="serviceFormSubHeading">
                                Upload a picture of the Damages
                              </h6>
                              <div className="serviceInputImgBox">
                                <div className="serviceInputFileBox">
                                  <img
                                    src="assets/images/icons/uploadImg.svg"
                                    alt="uploadImg"
                                    className="uploadImg"
                                  />
                                  <p className="uploadText">Upload</p>
                                  <input
                                    type="file"
                                    className="serviceInputFile"
                                    id="fileInput2"
                                    multiple
                                    onChange={(e) =>
                                      handleFileInputChange(e, "hip")
                                    }
                                  />
                                </div>
                                {hipImages.length > 0 && (
                                  <div
                                    className="uploadedImagesContainer"
                                    id="container2"
                                  >
                                    {hipImages.map((imageUrl, index) => (
                                      <div
                                        key={index}
                                        className="imageContainer"
                                      >
                                        <img
                                          src={imageUrl}
                                          alt={`Uploaded Image ${index}`}
                                          style={{
                                            width: "150px",
                                            height: "auto",
                                            marginBottom: "10px",
                                            position: "relative",
                                          }}
                                        />
                                        <button
                                          type="button"
                                          style={{
                                            position: "absolute",
                                            color: "red",
                                            fontSize: "24px",
                                            marginTop: "-19px",
                                            marginLeft: "-0.3%",
                                          }}
                                          onClick={() =>
                                            handleDeleteImage(index, "hip")
                                          }
                                        >
                                          x
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {hipImagesError && <p>{hipImagesError}</p>}
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-12">
                        <div className="viewbtnBox">
                          <button type="submit" className="SubmitBtn">
                            View Estimate Spread Sheet
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <DebrisRemovalModal
        show={showDebrisModal}
        handleClose={() => setShowDebrisModal(false)}
        handleSave={handleDebrisModalSave}
        stateId={selectedId}
        sqFt={watch("sq_ft")}
      />

      <Footer />
    </>
  );
};

export default WithLoginOurService;
